import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledLink = styled(Link)`
	font-family: Roboto;
	font-size: ${({size}) => size ? size : '1rem'};
	color: ${({color}) => color ? color : 'white'};
	text-decoration: none;
	transition: .5s ease-in-out;
	&:hover {
		color: white;
	}
`;

export default StyledLink;